import React, { useState, useEffect } from "react";
import jQuery from "jquery";
import $ from "jquery";
import HeaderDashboard from "../DashBoard/HeaderDashboard";
import Swal from "sweetalert2";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../Preloader";
import Cookies from "universal-cookie";
import LoginView from "../Login/LoginView";
//import ProjectServices from "../../../services/ProjectServices";
import ProductCategoryServices from "../../../services/ProductCategoryServices";
import AddOrEditProductCategory from "./AddOrEditProductCategory";
// var ProjectCategoryServicesObj = new ProjectServices();


var ProjectCategoryServicesObj = new ProductCategoryServices();
const ProductCategoryListTable = () => {
  const [Model, setModel] = useState({
    CategoryID: "",
    CategoryName: "",
    CategoryImagePath: ""
    // projectID: "",
    // name: "",
    // description: "",
    // imageUrl: "",
    // logoUrl: "",
    // projectOrder: "",
    // websiteUrl: "",
  });
  const [ProjectCategoryDetails, setProjectCategoryDetails] = useState([]);
  const cookies = new Cookies();
  const [Auth, SetAuth] = useState();
  const [showComponent, setShowComponent] = useState(false); // State to manage delay

  useEffect(() => {
    import("../Css/styleVt.css");
    import("../Css/bootsnav.css");
  
    // Delay for 1 second before showing the component
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, 100);
  });
  
  useEffect(() => {
    SetAuth(cookies.get("userID"));
    ProjectCategoryServicesObj.GetProjectList().then((res) => {
      
      if (res.data != null && res.data.length > 0) {
        setProjectCategoryDetails([...res.data]);
      }
      setTimeout(() => {
        $("#preloader").hide();
      }, 1000);
    });
  }, []);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 750,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  function GetEdit(
    CategoryID,
    CategoryName,
    CategoryImagePath
    // projectID,
    // name,
    // description,
    // imageUrl,
    // logoUrl,
    // projectOrder,
    // websiteUrl,
    // clientlogoUrls
  ) 
  
  {
    setModel({
    CategoryID: CategoryID,
    CategoryName: CategoryName,
    CategoryImagePath: CategoryImagePath
      // projectID: projectID,
      // name: name,
      // description: description,
      // imageUrl: imageUrl,
      // logoUrl: logoUrl,
      // projectOrder: projectOrder,
      // websiteUrl: websiteUrl,
      // clientlogoUrls: clientlogoUrls
    });
  }

  function DeleteProject(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want to Delete this Project?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        ProjectCategoryServicesObj.Delete(id).then((res) => {
          if (res.data == 1) {
            Toast.fire({
              icon: "success",
              title: "Delete Success",
            });
            setTimeout(function () {
              window.location.reload();
            }, 750);
          } else {
            Toast.fire({
              icon: "error",
              title: "Delete Failed!",
            });
          }
        });
      }
    });
  }

  if (!showComponent) {
    return null; // Or return a loading spinner, etc.
  }

  return Auth ? (
    <>
      <Preloader />
      <HeaderDashboard />
      <div class="main-panel">
        <div class="content">
          <div className="page-inner">
            <div class="row">
              <div class="col-md-12">
                <div class="card grid">

                  <div class="card-header">
                    <div class="d-flex align-items-center">
                      <h4 class="card-title">Category</h4>
                      <a
                        href="#"
                        className="btn btn-primary btn-round ml-auto"
                        data-toggle="modal"
                        data-target="#addRowModal"
                      >
                        <i className="fa fa-plus"></i>
                        Add Category
                      </a>
                    </div>
                  </div>

                  <div class="card-body">
                    <div class="table-responsive">
                      <table
                        className="display table table-striped table-hover"
                        id="AssociateDisplay"
                      >
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Product Name</th>
                            <th>Product Image</th>
                            <th style={{ textAlign: "center" }}>Action(s)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {" "}
                          {ProjectCategoryDetails != null &&
                            ProjectCategoryDetails.length > 0 ? (
                            ProjectCategoryDetails.map((v, i) => {
                              
                              return (
                                <tr key={i}>
                                  <td>{i+1}</td>
                                  <td>{v.categoryName}</td>
                                  <td>
                                    <img
                                      className="tableimage"
                                      src={
                                        process.env.REACT_APP_API_IMAGEPATH +
                                        v.categoryImagePath
                                      }
                                      alt="No Image"
                                    />
                                  </td>

                                  <td>
                                    <div class="form-button-action tableoptions"
                                     style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    >
                                      <button
                                        type="button"
                                        title=""
                                        class="btn btn-link  btn-lg"
                                        data-original-title="Edit"
                                        data-toggle="modal"
                                        data-target="#addRowModal"
                                        onClick={() =>
                                          GetEdit(
                                            v.categoryID,
                                            v.categoryName,
                                            v.categoryImagePath,
                                          )
                                        }
                                      >
                                        <FaPencilAlt style={{color:"#3B71CA"}}/>
                                      </button>

                                      <button
                                        type="button"
                                        data-toggle="tooltip"
                                        title=""
                                        class="btn btn-link "
                                        data-original-title="Remove"
                                        onClick={() =>
                                          DeleteProject(v.categoryID)
                                        }
                                      >
                                        <FaTrashAlt style={{color:"#DC4C64"}}/>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <label>No Data in Table</label>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div
          class="modal fade"
          id="addRowModal"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-backdrop="static"
        >
          <AddOrEditProductCategory Model={Model} />
        </div>
      </div>

      <footer className="bg-dark text-light">
        {/* Start Footer Bottom */}
        <div className="footer-bottom">
          <div className="container">
            <div className="footer-bottom-box">
              <div className="row">
                <div className="col-lg-12">
                  <p>
                    © Copyright 2012 - {new Date().getFullYear()}. All Rights
                    Reserved by{" "}
                    <a href="/Dashboardview"> Vaanam Technologies Pvt Ltd.</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ScrollToTop smooth color="#2b5690" />
        {/* End Footer Bottom */}
      </footer>
    </>
  ) : (
    <LoginView />
  );

}

export default ProductCategoryListTable


